export default __webpack_public_path__ + "static/media/Eye_3_M_C4.693c640a.svg";